module.exports = __webpack_public_path__ + "static/FSI_Logo-c6bbce5bcaee6a1ce7dc24b6f31e5b12.png";